import styled from 'styled-components';
import { Flex, useAsyncFunctionProgress, useDownloadFile } from '@equifinance/shared';
import Section from '../../Account/components/Section';
import { useTasksContext } from '../../../contexts/tasks';
import { TasksRefNames } from '../TasksSidebar';
import { HiddedA } from '../components/Evidence/DocumentaryEvidenceItem';
import { DownloadIcon, DownloadLink } from '../../Products/ProductComponents';
import useDocumentsApi, { TemplateCategory } from '../../../api/useDocumentsApi';

const ResourcesContainer = styled.div`${({ theme }) => `
  padding: ${theme.padding[4]} ${theme.padding[6]};
`}`;

const DownloadButton = styled(Flex)`${({ theme }) => `
  font-weight: ${theme.fontWeight.bold};
  align-items: center;
`}`;

const DownloadLinkText = styled(DownloadLink)`${({ theme }) => `
  text-decoration: none;
  border-bottom: ${theme.borderWidth[1]} solid ${theme.colours.link[1]};
`}`;

export default function ResourcesSection() {
  const { id, expandedStates, handleToggle } = useTasksContext();
  const {
    downloadFile, downloadFileRef,
  } = useDownloadFile();
  const { postDocumentTemplate } = useDocumentsApi();
  const onDownloadTemplate = async () => {
    const { fileName, documentData } = await postDocumentTemplate(id, {
      templateTypeId: 'CIS',
      category: TemplateCategory.Application,
    });
    if (fileName && documentData) {
      downloadFile(fileName, documentData);
    }
  };

  const { inProgress, execute: executeDownloadTemplate } = useAsyncFunctionProgress(onDownloadTemplate);

  return (
    <Section
      id={`${id}-resources`}
      refName={TasksRefNames.RESOURCES}
      titleIcon={<></>}
      title="Resources"
      collapsed={!expandedStates[TasksRefNames.RESOURCES]}
      onClickCollapse={() => handleToggle(TasksRefNames.RESOURCES)}
    >
      <ResourcesContainer>
        <DownloadButton>
          <HiddedA ref={downloadFileRef} />
          <DownloadIcon disabled={inProgress} className="mi-download" />
          <DownloadLinkText
            disabled={inProgress}
            onClick={() => {
              if (inProgress) return;
              executeDownloadTemplate();
            }}
            aria-hidden="true"
          >
            Information Sheet
          </DownloadLinkText>
        </DownloadButton>
      </ResourcesContainer>
    </Section>
  );
}
